import React from 'react';
import './NetworkAlert.css';
import ReactHtmlParser from 'react-html-parser';
const NetworkAlert = ({outageData})=>{
    
    const noDynamicData = outageData.resourcesummary;
    let isNooutage = noDynamicData === null;
    let outagestatus = "";
    let lastUpdatedTime="";
    let timeZone = "";
    let activityresponse = [];
    if(!isNooutage){
        // const activityresponse = noDynamicData.resourcesummary[0].insights.outage_activity_dtls.activity;
        // outagestatus = activityresponse.findIndex(
        //     (activity)=> activity.activity_progress === 100
        // ) !== -1 ? 'restored' : '';
        outagestatus = noDynamicData[0].insights.outagestatus;
    }
    if(!isNooutage && outagestatus!== 'RESOLVED'){
         activityresponse = noDynamicData[0].insights.outage_activity_dtls.activity;
         const activityCodes = activityresponse.map((activity)=> +activity.activity_progress);
         const latestActivity = activityresponse.find(
             (activity)=> +activity.activity_progress === Math.max(...activityCodes)
         );
         timeZone = noDynamicData[0].insights.timezone.trim();
         lastUpdatedTime = convertEDTZoneTime(latestActivity.activity_ts, timeZone);   
    }
    
    return (
        <div className="status-bar">
           {getRenderElement(isNooutage,outagestatus,lastUpdatedTime)}
           
        </div>
    )
}
function getRenderElement(isNooutage, outageStatus, lastUpdatedTime){
    if(isNooutage || outageStatus === 'RESOLVED'){
        return(
            
            <div className="Nooutage-Alert">
                <p className="Alert-Heading">
                    Snow in your area could impact your service. 
                </p>
                <span className="Get-Updates">
                    Get updates >
                </span>
            </div>
        )
    }else if(!isNooutage && outageStatus==='CLOSED'){
        return(
            <div className="Outage-Alert">
                <div className="Outage_Sub Outage-Restored">
                 <div className="restore-icon">
                     <div className="checkmark"></div>
                 </div>
                <div className="alert-right">
                <p className="headline-1">
                Service fully restored
                </p>
                <p >
                Restored {lastUpdatedTime}
                </p>
                </div>
                </div>
               </div>
        )
    }else{
        return (
            <div className="Outage-Alert">
            <div className="Outage_Sub">
           
                <div id="warning-symbol" className="warning-symbol">
                    <svg version="1.1" id="Ebene_1" role="img" className="svg_icon" aria-labelledby="alertTitle" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 18.2 18.4"><title id="alertTitle">Alert Icon</title><g><path d="M17.5,7.8l-7-7c-0.4-0.4-0.9-0.6-1.4-0.6s-1,0.2-1.4,0.6l-7,7c-0.8,0.8-0.8,2,0,2.8l7,7c0.4,0.4,0.9,0.6,1.4,0.6
                    s1-0.2,1.4-0.6l7-7C18.3,9.8,18.3,8.6,17.5,7.8z M16.7,9.8l-7,7c-0.2,0.2-0.4,0.2-0.6,0.2S8.7,17,8.5,16.8l-7-7
                    C1.3,9.6,1.2,9.4,1.2,9.2s0.1-0.4,0.2-0.6l7-7c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0.1,0.6,0.2l7,7C16.9,8.8,17,9,17,9.2
                    S16.9,9.6,16.7,9.8z"></path><polygon points="9.5,11 9.8,7.3 9.8,4.7 8.4,4.7 8.4,7.3 8.8,11 	"></polygon><rect x="8.4" y="12.2" width="1.5" height="1.5"></rect></g></svg>
                </div>
        
            <div style={{paddingLeft:'28px'}}>
            <p className="headline-1">
            Network outage detected
            </p>
            <p >
            Last updated {lastUpdatedTime}
            </p>
            </div>
            </div>
           </div>
        )
    }

}
function convertTo12HourFormat(time) {
    let meridianTime = "";
    if (time !== "" && parseFloat(time.substring(0, time.indexOf(":"))) < 12) {
        meridianTime = time.substring(0, time.indexOf(":")) + time.substring(time.indexOf(":")) + " AM"
    } else if (time !== "") {
        let PMtime = (parseFloat(time.substring(0, time.indexOf(":"))) - 12 === 0) ? "12" : (parseFloat(time.substring(0, time.indexOf(":"))) - 12);
        meridianTime = (PMtime + time.substring(time.indexOf(":"))) + " PM"
    }
    return meridianTime;
}

function convertEDTZoneTime(time,timezone) {
    if (time !== null && time !== undefined) {
        let months = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
        const montsCount =["01","02","03","04","05","06","07","08","09","10","11","12"];
        let splitTime = time.split('-');
        let splittedMonth = splitTime[1].toLowerCase();
        let restorationTime = months.map((item, index) => {
            if (months[index].indexOf(splittedMonth) > -1) {
                const EDTTime = montsCount[index] + "/" + splitTime[0] + "/" + splitTime[2].substring(0, splitTime[2].indexOf(" ")) + " - " + convertTo12HourFormat(splitTime[2].substring(splitTime[2].indexOf(" ") + 1, splitTime[2].lastIndexOf(":"))) + " "+ timezone.trim();
                return EDTTime;
            }
        })
        return restorationTime.filter((el)=>el);
    }
}
export default NetworkAlert;


// WEBPACK FOOTER //
// ./src/components/NetworkOutage/NetworkFeedback/NetworkAlert/NetworkAlert.js